import { useNavigate } from 'react-router';
import { useTranslation } from 'react-i18next';
import { useTopBarIdentity } from './useTopBarIdentity';
import { useTopBarNotifications } from './useTopBarNotifications';
import { useTopBarLogout } from './useTopBarLogout';
import { useTopBarLanguage } from './useTopBarLanguage';
import { useTopBarSettingsAccess } from './useTopBarSettingsAccess';

export const useTopBar = () => {
	const { t } = useTranslation();
	const navigate = useNavigate();

	const identity = useTopBarIdentity();
	const notifications = useTopBarNotifications();
	const logout = useTopBarLogout();
	const language = useTopBarLanguage();
	const settingsAccess = useTopBarSettingsAccess();

	return {
		t,
		navigate,
		...identity,
		...notifications,
		...logout,
		...language,
		...settingsAccess,
	};
};
